import axios from '@/plugins/axios'

export default {
    googleAnalyticsAuth(query) {
        let {page_path=''} = query
        return axios({
            url: '/googleapi/analytics-oauth',
            method: 'get',
            params: {
                page_path
            }
        })
    },
    chooseProfile(data) {
        return axios({
            url: '/googleapi/analytics-choose-profile',
            method: 'post',
            data
        })
    },
    getListProfile() {
        return axios({
            url: '/googleapi/analytics-get-profile',
            method: 'get'
        })
    }
}
